import { useEffect, useState } from 'react';
import type { SidebarMode } from '@/hooks/use-desktop-sidebar';

/**
 * The sidebar's mode on screen (D2): Review (or any panel in a narrow window) takes the width, so the
 * open sidebar collapses to its rail meanwhile, unless the user opens it again then. A page over
 * the shell (Settings, the Library) changes none of it: back from it (Settings › Back to app),
 * the frame is the one the user left, a rail if it was one (M13).
 */
export function useSidebarRail(input: {
  chosen: SidebarMode;
  panelNeedsWidth: boolean;
  setChosen: (mode: SidebarMode) => void;
}): { mode: SidebarMode; expand: () => void } {
  const { chosen, panelNeedsWidth, setChosen } = input;
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (!panelNeedsWidth) setDismissed(false);
  }, [panelNeedsWidth]);
  return {
    mode: chosen === 'open' && panelNeedsWidth && !dismissed ? 'rail' : chosen,
    expand: () => {
      if (chosen === 'open') setDismissed(true);
      else setChosen('open');
    },
  };
}
